import debounce from 'just-debounce-it'
import Vue from 'vue'

Vue.directive('highlight-on-element', {
	bind: function (el, binding, vnode) {
		window.addEventListener('scroll', debounce(() => {
			let highlightEl = document.querySelector(`#${binding.value}`)

			if (highlightEl.offsetTop <= window.scrollY && window.scrollY <= highlightEl.offsetTop + highlightEl.offsetHeight) {
				el.classList.add('highlight-on-element')
			} else {
				el.classList.remove('highlight-on-element')
			}
		}), 100)
	}
})